<template>
  <v-card>
    <v-card-title class="title">
      Image gallery
    </v-card-title>
    <v-card-text id="carousel" class="my-3" v-if="organization.photos.length > 0">
      <carousel :controls-visible="true" :clickable="false">
        <slide v-for="(photo, i) in organization.photos" :index="i" :key="`photo-${i}`">
          <figure>
            <img v-img-orientation-changer :src="photo.url">
            <figcaption v-text="photo.caption"></figcaption>
          </figure>
        </slide>
      </carousel>
    </v-card-text>
    <v-card-text v-else>
      No images have been added.
    </v-card-text>
  </v-card>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  computed: mapGetters({ organization: 'client/organization/model' })
}
</script>
